import Button from '~/components/common/Button';
import buttonStyles from '~/components/common/Button/Button.module.css';
import List from '~/components/common/List';
import Modal from '~/components/common/Modal';
import Stepper from '~/components/common/Stepper';
import VerifyingLoader from '~/components/Loaders/VerifyingLoader';
import { type ITrackingProps } from '~/services/actions/tracking-actions';
import {
  SUBSCRIPTION_INTERVAL,
  SUBSCRIPTION_TERM,
  type SubscriptionTerm } from
'~/utils/getSubscriptionTerm';

import { ModalStatus, useSubscribeStore } from '../store/subscribe.store';

import styles from './Modal.module.css';

export const SubscribeModal = ({
  productPaymentTerm,
  productPrice,
  redirectPath,
  resourcesUrl,
  sendCustomEvent,
  subscriptionList,
  userId








}: {productPaymentTerm: SubscriptionTerm | null;productPrice: string | null;redirectPath: string | null;resourcesUrl: string;sendCustomEvent: (obj: ITrackingProps) => void;subscriptionList: string[];userId: string;}) => {
  const modalStatus = useSubscribeStore((state) => state.modalStatus);
  const setModalStatus = useSubscribeStore((state) => state.setModalStatus);

  const isModalOpen =
  modalStatus !== ModalStatus.HIDDEN &&
  modalStatus !== ModalStatus.ERROR &&
  modalStatus !== ModalStatus.CANCELLED;

  const redirectUrl = redirectPath || '/';

  const completeImage =
  <img
    alt="Complete"
    src={`${resourcesUrl}/assets/img/subscribe/complete.png`} />;



  const steps = ['Sign up', 'Subscription', 'Confirmation'];

  const getTermDenominator = (term: SubscriptionTerm) => {
    switch (term) {
      case SUBSCRIPTION_TERM.ANNUAL:
        return SUBSCRIPTION_INTERVAL.YEAR.toLowerCase();
      case SUBSCRIPTION_TERM.MONTHLY:
        return SUBSCRIPTION_INTERVAL.MONTH.toLowerCase();
      default:
        return 1;
    }
  };

  const confirmSubscription = () => {
    const event = new CustomEvent('OC:InvalidateMyOC');
    window.dispatchEvent(event);

    sendCustomEvent({
      event: 'paymentVerified',
      eventLabel: 'subscription-modal-continue-button-clicked',
      event_name: 'paymentVerified',
      product: `${productPrice ? productPrice : ''}${productPaymentTerm ? `/${getTermDenominator(productPaymentTerm)}` : ''}`,
      userId
    });
    setModalStatus(ModalStatus.COMPLETE);
  };

  const stages = {
    [ModalStatus.VERIFYING]: {
      stepText: 'Subscription',
      titleImage: <VerifyingLoader />,
      isComplete: false,
      title: 'Verifying Payment',
      content:
      <p className={styles['align-center']}>
					One moment. We're just verifying your payment.
				</p>,

      footer: undefined
    },
    [ModalStatus.CONFIRMED]: {
      stepText: 'Subscription',
      titleImage: completeImage,
      isComplete: true,
      title: 'Payment Verified',
      content: undefined,
      footer: <Button buttonText="Continue" onClick={confirmSubscription} />
    },
    [ModalStatus.COMPLETE]: {
      stepText: 'Confirmation',
      titleImage: undefined,
      isComplete: true,
      title: 'Subscribed successfully!',
      content: [
      <p key="confirmation-step-description">
					Unlimited access to all of oddschecker
				</p>,
      <List
        hasColumns
        key="successful-subscription-list"
        list={subscriptionList}
        mode="dark"
        name="benefits of subscription"
        resourcesUrl={resourcesUrl} />],


      footer:
      <a className={buttonStyles.button} href={redirectUrl}>
					Start using premium
				</a>

    }
  };

  const activeStep = isModalOpen && modalStatus ? stages[modalStatus] : null;

  const stepper =
  <>
			{activeStep &&
    <Stepper
      activeStep={activeStep.stepText}
      isActiveStepComplete={activeStep.isComplete}
      resourcesUrl={resourcesUrl}
      stepperName="Subscription progress indicator"
      steps={steps} />

    }
		</>;


  return (
    <>
			{activeStep &&
      <Modal
        content={activeStep.content}
        footer={activeStep.footer}
        heading={stepper}
        isOpen={isModalOpen}
        modalName="Subscribe to oddschecker premium"
        title={activeStep.title}
        titleImage={activeStep.titleImage} />

      }
		</>);

};